import React, { Component } from "react"
import BaseModal, { ModalActions, SaveButton, CancelButton } from "../../../../containers/UI/Modal/BaseModal";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow"


class FilterModal extends Component {

  state = {
    part: "all-parts",
  }
  allParts = { label: "All parts", value: "all-parts" }

  componentDidMount() {
    if (this.props.filteredPart !== "") {
      this.setState({ part: this.props.filteredPart })
    }
  }

  
  render() {

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title="Filter stock bookings"
      >
        <SelectRow
          title="Show bookings for"
          firstRow
          ultrawide
          defaultValue={"all-parts"}
          value={this.state.part}
          onChange={(newValue) => this.setState({ part: newValue.value })}
          options={[this.allParts, ...this.props.partOptions]}/>

        <ModalActions>
          <CancelButton onClick={this.props.closeModal}/>
          <SaveButton onClick={() => { this.props.applyFilter(this.state.part); this.props.closeModal() }}>
            Apply
          </SaveButton>
        </ModalActions>
      </BaseModal>
    )
  }
}


export default FilterModal;
